const apiBaseURL = 'https://fwxu1tnnsb.execute-api.ap-northeast-1.amazonaws.com/production'

const Config = {
  cognitoSetting: {
    admin: {
      region: 'ap-northeast-1',
      IdentityPoolId: 'ap-northeast-1:d772cd21-9205-41ef-a295-4f2a7cd4e740',
      UserPoolId: 'ap-northeast-1_DafU9hGMb',
      ClientId: '4splsbe56kgtfr4as19849dvq6'
    },
    companyAdmin: {
      region: 'ap-northeast-1',
      IdentityPoolId: 'ap-northeast-1:eeaa2db1-b553-49ee-b919-93a7608dc1fb',
      UserPoolId: 'ap-northeast-1_ErimPmC2D',
      ClientId: '6rk67l9jvsjnvgkmi1nqeah0pk'
    },
    companyUser: {
      region: 'ap-northeast-1',
      IdentityPoolId: 'ap-northeast-1:1067437c-a559-4112-8ca6-cc67b1607406',
      UserPoolId: 'ap-northeast-1_BTaf1qEmY',
      ClientId: '47hbsncdq71sjdh8fraqsv7if9'
    }
  },
  adminSharedfileSetting: {
    AccountId: '022499048122',
    RoleArn: 'arn:aws:iam::022499048122:role/service-role/Katawaku_Admin',
    IdentityPoolId: 'ap-northeast-1:d772cd21-9205-41ef-a295-4f2a7cd4e740',
    Logins: 'cognito-idp.ap-northeast-1.amazonaws.com/ap-northeast-1_DafU9hGMb',
    Bucket: 'katawaku-upload-files2'
  },
  adminApiUrl: {
    actionLog: apiBaseURL + '/admin/action-log',
    systemSettings: apiBaseURL + '/admin/system-settings',
    sharedFileDownlaod: apiBaseURL + '/admin/s3-presigned-url',
    emailChange: apiBaseURL + '/admin/email-change',
    userManagement: apiBaseURL + '/admin/user-management',
    estimation: apiBaseURL + '/admin/estimation',
    surveySetting: apiBaseURL + '/admin/survey-setting',
    surveyQuestionSetting: apiBaseURL + '/admin/survey-question-setting',
  },
  companyAdminApiUrl: {
    actionLog: apiBaseURL + '/company-admin/action-log',
    systemSettings: apiBaseURL + '/company-admin/system-settings',
    sharedFileDownlaod: apiBaseURL + '/company-admin/s3-presigned-url',
    emailChange: apiBaseURL + '/company-admin/email-change',
    companyUser: apiBaseURL + '/company-admin/company-user',
    selfUser: apiBaseURL + '/company-admin/self-user',
    selfUserNoLogin: apiBaseURL + '/company-admin/self-user-no-login',
    surveyAnswer: apiBaseURL + '/company-admin/survey-answer',
  },
  companyUserApiUrl: {
    actionLog: apiBaseURL + '/company-user/action-log',
    systemSettings: apiBaseURL + '/company-user/system-settings',
    sharedFileDownlaod: apiBaseURL + '/company-user/s3-presigned-url',
    emailChange: apiBaseURL + '/company-user/email-change',
    estimation: apiBaseURL + '/company-user/estimation',
    surveyAnswer: apiBaseURL + '/company-user/survey-answer',
    surveyAnswerNonLogin: apiBaseURL + '/company-user/survey-answer-non-login',
  },
  estimation: {
    nameOptions: [
      {
        name: '基礎型枠'
      },
      {
        name: '地下型枠'
      },
      {
        name: '地上普通型枠'
      },
      {
        name: '地上打放型枠'
      },
      {
        name: '地上化粧打放型枠'
      },
      {
        name: '捨てコン型枠'
      },
      {
        name: '打継目地型枠'
      },
      {
        name: '誘発目地型枠'
      },
      {
        name: 'スタイロフォーム打込み手間'
      }
    ],
    unitOptions: [
      {
        name: '㎡'
      },
      {
        name: 'm'
      },
      {
        name: '式'
      },
      {
        name: '箇所'
      }
    ]
  },
  prefectures: {
    nameOptions: [
      {
        name: '北海道'
      },
      {
        name: '青森県'
      },
      {
        name: '岩手県'
      },
      {
        name: '宮城県'
      },
      {
        name: '秋田県'
      },
      {
        name: '山形県'
      },
      {
        name: '福島県'
      },
      {
        name: '茨城県'
      },
      {
        name: '栃木県'
      },
      {
        name: '群馬県'
      },
      {
        name: '埼玉県'
      },
      {
        name: '千葉県'
      },
      {
        name: '東京都'
      },
      {
        name: '神奈川県'
      },
      {
        name: '新潟県'
      },
      {
        name: '富山県'
      },
      {
        name: '石川県'
      },
      {
        name: '福井県'
      },
      {
        name: '山梨県'
      },
      {
        name: '長野県'
      },
      {
        name: '岐阜県'
      },
      {
        name: '静岡県'
      },
      {
        name: '愛知県'
      },
      {
        name: '三重県'
      },
      {
        name: '滋賀県'
      },
      {
        name: '京都府'
      },
      {
        name: '大阪府'
      },
      {
        name: '兵庫県'
      },
      {
        name: '奈良県'
      },
      {
        name: '和歌山県'
      },
      {
        name: '鳥取県'
      },
      {
        name: '島根県'
      },
      {
        name: '岡山県'
      },
      {
        name: '広島県'
      },
      {
        name: '山口県'
      },
      {
        name: '徳島県'
      },
      {
        name: '香川県'
      },
      {
        name: '愛媛県'
      },
      {
        name: '高知県'
      },
      {
        name: '福岡県'
      },
      {
        name: '佐賀県'
      },
      {
        name: '長崎県'
      },
      {
        name: '熊本県'
      },
      {
        name: '大分県'
      },
      {
        name: '宮崎県'
      },
      {
        name: '鹿児島県'
      },
      {
        name: '沖縄県'
      }
    ]
  },
  branch: {
    nameOptions: [
      {
        name: '北海道'
      },
      {
        name: '青森'
      },
      {
        name: '岩手'
      },
      {
        name: '宮城'
      },
      {
        name: '秋田'
      },
      {
        name: '山形'
      },
      {
        name: '福島'
      },
      {
        name: '茨城'
      },
      {
        name: '栃木'
      },
      {
        name: '群馬'
      },
      {
        name: '埼玉'
      },
      {
        name: '千葉'
      },
      {
        name: '東京'
      },
      {
        name: '神奈川'
      },
      {
        name: '新潟'
      },
      {
        name: '富山'
      },
      {
        name: '石川'
      },
      {
        name: '福井'
      },
      {
        name: '山梨'
      },
      {
        name: '長野地区'
      },
      {
        name: '東海'
      },
      {
        name: '静岡'
      },
      {
        name: '京都'
      },
      {
        name: '近畿'
      },
      {
        name: '鳥取'
      },
      {
        name: '島根'
      },
      {
        name: '岡山'
      },
      {
        name: '中国'
      },
      {
        name: '四国'
      },
      {
        name: '九州'
      },
      {
        name: '沖縄'
      },
    ]
  },
  sessionTimeout: {
    total: 120 * 60 * 1000,
    alertDelay: 10 * 60 * 1000
  },
}

export default Config



// WEBPACK FOOTER //
// ./src/Config.js